            
<template>  
  <div>    
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row style="width:100%">   
                    <b-col md="3" lg="3">
                       <b-form-group
                        label="Saldo"
                      >                      
                        <b-input-group size="sm" prepend="$" append="">
                          <b-form-input v-model="dataForm[namePath].info_ventas.saldo" disabled trim></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>           
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="fecha_entrega"
                      :lg="6"
                      :md="6">
                    </sw-inputs>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            nameBtn="Entrega de producto"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  created(){
    if(this.indexData!==false)
    {
      this.updateDataForm({state: 'info_ventas', data: this.dataGet[this.namePath].data[this.indexData].info_ventas})
      this.updateDataForm({state: 'info_ventas/abono', data: this.dataGet[this.namePath].data[this.indexData].info_ventas.saldo})
      this.updateDataForm({state: 'info_orden', data: this.dataGet[this.namePath].data[this.indexData].info_orden})
     }    
  },
  computed: { 
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'entregaFtn' })
    }
  }
}
</script>
<style>
</style>